// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__1DlTF","file":"styles_file__3HeDM"};